import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table = _resolveComponent("el-table");
  const _component_select_favorite = _resolveComponent("select-favorite");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_table, {
    data: $props.assetsList,
    "header-cell-style": {
      background: '#FAFAFA'
    },
    onSelectionChange: $setup.handleSelectionChange
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      type: "selection"
    }), _createVNode(_component_el_table_column, {
      prop: "srcTyp",
      label: "文件类型"
    }, {
      default: _withCtx(scope => [_createElementVNode("img", {
        style: {
          "width": "30px",
          "height": "30px"
        },
        src: $setup.srcType[scope.row.srcTyp] && $setup.srcType[scope.row.srcTyp].src ? $setup.srcType[scope.row.srcTyp].src : $setup.srcType[6].src
      }, null, 8, _hoisted_1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "assetsName",
      label: "素材名称",
      "show-overflow-tooltip": "",
      width: "200"
    }), _createVNode(_component_el_table_column, {
      label: "素材内容",
      "show-overflow-tooltip": "",
      width: "250"
    }, {
      default: _withCtx(scope => [scope.row.srcTyp === '1' ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        style: {
          "max-width": "50px",
          "height": "50px"
        },
        fit: "scale-down",
        src: scope.row.srcOutUrl ? scope.row.srcOutUrl : scope.row.srcInnUrl + '_s',
        "preview-src-list": [scope.row.srcOutUrl ? scope.row.srcOutUrl : scope.row.srcInnUrl + '_s']
      }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true), scope.row.srcTyp === '7' ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row.content), 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "createTime",
      label: "入库时间"
    }), _createVNode(_component_el_table_column, {
      prop: "bgnDate",
      label: "生效时间"
    }), _createVNode(_component_el_table_column, {
      prop: "endDate",
      label: "失效时间"
    }), _createVNode(_component_el_table_column, {
      prop: "endDate",
      label: "文件大小"
    }, {
      default: _withCtx(scope => [scope.row.srcFileLength ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString((scope.row.srcFileLength / 1024 / 1024).toFixed(2)) + "M", 1)) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "favorite",
      label: "收藏"
    }, {
      default: _withCtx(scope => [_createElementVNode("i", {
        class: _normalizeClass([{
          'el-icon-star-on': scope.row.favorite == true,
          'el-icon-star-off': scope.row.favorite == false
        }, "coll"]),
        onClick: _withModifiers($event => $setup.favHandler(scope.row), ["stop"])
      }, null, 10, _hoisted_4)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      fixed: "right",
      label: "操作",
      width: "80"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_button, {
        onClick: $event => $setup.showDetail(scope.row),
        link: "",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("查看详情 ", -1)]))]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data", "onSelectionChange"]), _createVNode(_component_select_favorite, {
    ref: "selectFavoriteRef",
    choseAsset: _ctx.choseAsset,
    onOk: $setup.favorited
  }, null, 8, ["choseAsset", "onOk"])]);
}